"use client"
import React, { useState, useEffect } from "react";
import ProfileTypeIcon from "@/components/shared/ProfileTypeIcon";
import { useConfig } from "@/lib/providers/ConfigProvider";
import { Ratio } from "react-bootstrap";
import UralityImage from "@/components/shared/UralityImage";
import Asset from "@/components/shared/Asset";

import "@/components/shared/ContentCard.css";
import UralityAvatarImage from "@/components/shared/UralityAvatarImage";
import PlaceTypeLabel from "@/components/shared/PlaceTypeLabel";
import CommunityAccoladeBadge from "@/components/communities/CommunityAccoladeBadge";
import LocationOpenHoursLink from "@/components/shared/LocationOpenHoursLink";
import MapLink from "@/components/shared/MapLink";
import AmenityViewList from "@/components/categories/AmenityViewList";
import EventDateAndTime from "@/components/shared/EventDateAndTime";
import EventCalendarLink from "@/components/shared/EventCalendarLink";
import SocialLinks from "@/components/social/SocialLinks";
import { useMediaQuery } from "react-responsive";
import LocationHoursText from "@/components/shared/LocationHoursText";
import VolunteerLink from "@/components/campaign/VolunteerLink";
import { useAppData } from "@/lib/providers/AppDataProvider";

var moment = require("moment");

const ContentCard = ({
  name,
  id,
  className,
  type,
  content,
  community,
  external,
  waypoint,
  clickable = true,
  coverBase64,
  logoBase64,
  pinned = false,
  showSocialProfile = false,
  showDescription = true,
  showBio = false,
  showVendorProfile = false
}) => {
  const { webUrl } = useConfig();
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });
  const [url, setUrl] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const { flattenedVendorTypes: vendorProfileTypes } = useAppData();

  useEffect(() => {
    if (type && content) {
      setUrl(generateUrl(type, content));
      setLoaded(true);
    }
  }, [type, content]);

  const generateUrl = (type, content) => {
    if (clickable) {
      // console.log("ContentCard generateUrl", type, content);
      if (type === "USER_PROFILE") {
        return `${webUrl}${name}/community/members/${content.resourceName}`;
      } else if (type === "EVENT") {
        return `${webUrl}${content.owner.resourceName}/events/${content.id}?community=${name}`;
      } else if (type === "POST") {
        return `${webUrl}${content.owner.resourceName}/pins/${content.id}?community=${name}`;
      } else if (type === "STORY" || type === "MAP") {
        return `${webUrl}${content.owner.resourceName}/stories/${content.id}?community=${name}`;
      } else {
        return null;
      }
    } else {
      return "#";
    }
  };

  const typeIcon = (type, content) => {
    if (type === "USER_PROFILE") {
      return <ProfileTypeIcon type={content.userProfileType} />;
    } else {
      return <ProfileTypeIcon type={type} />;
    }
  };

  const typeLabel = (type, content) => {
    if (type === "USER_PROFILE") {
      if (content.userProfileType === "BUSINESS") return "Business";
      else if (content.userProfileType === "POI") return "Point of Interest";
      else if (content.userProfileType === "AMBASSADOR") return "Ambassador";
      else if (content.userProfileType === "COMMUNITY") return "Community";
      else return "";
    } else if (type === "EVENT") {
      return "Event";
    } else if (type === "POST") {
      return "Map Pin";
    } else if (type === "STORY" || type === "MAP") {
      return "Story Map";
    } else {
      return "";
    }
  };

  const header = (
    <div className="header">
      {typeIcon(type, content)}
      <h4>{typeLabel(type, content)}</h4>
      <div className="flex-grow" />
      {url && (
        <a href={url} target={external ? "_blank" : "_self"} rel="noreferrer">
          View
        </a>
      )}
    </div>
  );

  const media = (type, content, base64) => {
    if (base64) {
      if (type === "USER_PROFILE") {
        return (
          <Ratio aspectRatio="16x9">
            <UralityImage size="md" base64={base64} />
          </Ratio>
        );
      } else {
        return <></>;
      }
    } else {
      if (type === "USER_PROFILE" || type === "EVENT" || type === "STORY") {
        var imageId = null;
        if (type === "USER_PROFILE" || type === "STORY") {
          imageId = content.coverPhotoId;
        } else if (type === "EVENT") {
          if (content.coverPhotoAsset) {
            imageId = content.coverPhotoAsset.id;
          }
        }
        return (
          <Ratio aspectRatio="16x9">
            <UralityImage size="md" imageId={imageId} />
          </Ratio>
        );
      } else if (type === "POST") {
        return <Asset assets={content.mapPoint.assets} />;
      } else {
        return <></>;
      }
    }
  };

  const avatarTitle = (type, content) => {
    if (type === "USER_PROFILE") {
      return content.displayName;
    } else {
      return content.title;
    }
  };

  const amenities = (type, content) => {
    if (
      type === "USER_PROFILE" &&
      (content.userProfileType === "BUSINESS" ||
        content.userProfileType === "POI") &&
      content.amenities &&
      content.amenities.length > 0
    ) {
      return (
        <>
          <AmenityViewList profile={content} condensed={false} />
          {separator()}
        </>
      );
    } else {
      return <></>;
    }
  };

  const avatarAndTitle = (type, content, base64) => {
    if (base64) {
      return (
        <div className="avatar-and-title">
          {/*{type === "USER_PROFILE" && (*/}
          {/*  <UralityAvatarImage*/}
          {/*    temporaryImage={base64}*/}
          {/*    size="sm"*/}
          {/*    name={*/}
          {/*      type === "USER_PROFILE"*/}
          {/*        ? content.displayName*/}
          {/*        : content.owner.displayName*/}
          {/*    }*/}
          {/*    type={*/}
          {/*      type === "USER_PROFILE"*/}
          {/*        ? content.userProfileType*/}
          {/*        : content.owner.userProfileType*/}
          {/*    }*/}
          {/*  />*/}
          {/*)}*/}
          <div className="title">
            {clickable && url ? (
              <a
                href={url}
                target={external ? "_blank" : "_self"}
                rel="noopener noreferrer"
              >
                <h4>{avatarTitle(type, content)}</h4>
              </a>
            ) : (
              <h4>{avatarTitle(type, content)}</h4>
            )}
            {type === "USER_PROFILE" && (
              <PlaceTypeLabel
                values={content.types}
                mutliple={true}
                as="span"
              />
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div className="avatar-and-title">
          {/*{type === "USER_PROFILE" && (*/}
          {/*  <UralityAvatarImage*/}
          {/*    imageId={content.logoId}*/}
          {/*    size="sm"*/}
          {/*    name={content.displayName}*/}
          {/*    type={content.userProfileType}*/}
          {/*  />*/}
          {/*)}*/}
          <div className="title">
            {clickable && url ? (
              <a
                href={url}
                target={external ? "_blank" : "_self"}
                rel="noopener noreferrer"
              >
                <h4>{avatarTitle(type, content)}</h4>
              </a>
            ) : (
              <h4>{avatarTitle(type, content)}</h4>
            )}
            {type === "USER_PROFILE" && (
              <PlaceTypeLabel
                values={content.types}
                mutliple={true}
                as="span"
              />
            )}
          </div>
        </div>
      );
    }
  };

  const descriptiveText = (type, content) => {
    if (type === "USER_PROFILE" || type === "EVENT") {
      return content.description && content.description !== "" ? (
        <p className="descriptive-text">{content.description}</p>
      ) : (
        <p className="descriptive-text">No description provided.</p>
      );
    } else {
      return content.text && content.text !== "" ? (
        <p className="descriptive-text">{content.text}</p>
      ) : (
        <p className="descriptive-text">No description provided.</p>
      );
    }
  };

  const accolades = (type, content) => {
    if (
      type === "USER_PROFILE" &&
      content.accolades &&
      content.accolades.length > 0
    ) {
      return (
        <div className="accolade-badge-list">
          {content.accolades.map(function(accolade, index) {
            return (
              <CommunityAccoladeBadge
                accolade={accolade}
                enableHover={true}
                small={true}
              />
            );
          })}
        </div>
      );
    }
  };

  const hoursLink = (type, content) => {
    if (
      type === "USER_PROFILE" &&
      content.userProfileType === "BUSINESS" &&
      content.location &&
      content.location.hours
    ) {
      return (
        <LocationOpenHoursLink location={content.location} showIcon={true} />
      );
    } else {
      return <></>;
    }
  };

  const mapLink = (type, content) => {
    if (type === "USER_PROFILE" && content.location) {
      if (content.location.address) {
        return <MapLink location={content.location} clickable={clickable} />;
      } else {
        return <></>;
      }
    } else if (type === "EVENT" || type === "STORY") {
      if (content.location) {
        return <MapLink location={content.location} clickable={clickable} />;
      }
    } else if (type === "POST") {
      if (content.mapPoint && content.mapPoint.location) {
        return (
          <MapLink location={content.mapPoint.location} clickable={clickable} />
        );
      }
    } else {
      return <></>;
    }
  };

  const phoneLink = (type, content) => {
    if (type === "USER_PROFILE" && content.location) {
      if (content.location.phoneNumber) {
        return (
          <a
            className={clickable ? "" : "style-as-div"}
            href={"tel:" + content.location.phoneNumber}
          >
            <div className="with-icon">
              <i className="fa-solid fa-phone"></i>
              <span>{content.location.phoneNumber}</span>
            </div>
          </a>
        );
      } else {
        return <></>;
      }
    } else {
      return <></>;
    }
  };

  const dateAndTime = (type, content) => {
    if (type === "EVENT") {
      return (
        <div className="date-and-time with-icon">
          <i className="fa-solid fa-clock"></i>
          <EventDateAndTime
            startDate={moment(content.startDate.date)}
            endDate={moment(content.endDate.date)}
            multiDay={content.multiDay}
          />
        </div>
      );
    } else {
      return <></>;
    }
  };

  const details = (type, content) => {
    return (
      <div
        className="default-flex-column-layout info"
        style={{ gap: "0.5rem" }}
      >
        {hoursLink(type, content)}
        {dateAndTime(type, content)}
        {mapLink(type, content)}
        {phoneLink(type, content)}
      </div>
    );
  };

  const separator = () => {
    return <div className="separator" />;
  };

  const cta = (type, content) => {
    if (type === "USER_PROFILE") {
      return <></>;
    } else if (type === "EVENT") {
      if (content.eventType === "MARKETING") {
        if (
          content.socialProfile &&
          content.socialProfile.findIndex(sp => sp.type === "WEBSITE") > -1
        ) {
          var website = content.socialProfile.find(sp => sp.type === "WEBSITE");
          return (
            <a
              href={website.value}
              className="btn btn-secondary content-card-cta"
              target="_self"
              rel="noopener noreferrer"
            >
              View Event Page
            </a>
          );
        } else if (content.enableEventMap) {
          return (
            <a
              href={`${webUrl}${content.resourceName}/events/${content.id}`}
              className="btn btn-secondary content-card-cta"
              target="_self"
              rel="noopener noreferrer"
            >
              View Event Page
            </a>
          );
        } else {
          return (
            <EventCalendarLink
              event={content}
              className="content-card-cta btn btn-secondary"
              addIcon={false}
            />
          );
        }
      } else if (content.eventType === "VOLUNTEER") {
        return <VolunteerLink name={name} event={content} />;
      }
    } else if (type === "POST") {
      return <></>;
    } else if (type === "STORY_MAP") {
      return (
        <a
          href={`${webUrl}${content.resourceName}/stories/${content.id}`}
          className="btn btn-secondary content-card-cta"
          target="_self"
          rel="noopener noreferrer"
        >
          View Story Map
        </a>
      );
    } else {
      return <></>;
    }
  };

  // const pinnedIndicator = (
  //   <div className="pinned-indicator">
  //     <span className="material-icons orange">star_border</span>
  //   </div>
  // );

  const profileBio = bio => {
    return (
      <div className="profile-bio">
        <h6>About</h6>
        <p className={"bio"}>{bio.about}</p>
      </div>
    );
  };

  const vendorProfile = vendorProfile => {
    let macroType;
    if (vendorProfile.macroType) {
      macroType = vendorProfileTypes.find(
        vpt => vpt.value === vendorProfile.macroType
      );
    }
    let microTypes;
    if (vendorProfile.products && macroType) {
      microTypes = vendorProfileTypes.filter(vpt =>
        vendorProfile.products.includes(vpt.value)
      );
    }
    if (macroType || microTypes) {
      return (
        <>
          <div className="default-flex-column-layout info">
            {macroType && vendorMacroType(macroType)}
            {microTypes && vendorMicroTypes(microTypes)}
          </div>
          {separator()}
        </>
      );
    } else {
      return <></>;
    }
  };

  const vendorMacroType = macroType => {
    return (
      <div className="tags">
        <span className="tag">{macroType.label}</span>
      </div>
    );
  };

  const vendorMicroTypes = microTypes => {
    return (
      <div className="micro-tags">
        {microTypes.map(mt => (
          <span className="tag">{mt.label}</span>
        ))}
      </div>
    );
  };

  if (content && loaded) {
    return (
      <div
        className={`urality-content-card ${className} ${
          clickable ? "" : "not-clickable"
        }`}
        key={`urality-content-card-${content.id}`}
      >
        <div className="default-card-wrapper">
          {media(type, content, coverBase64)}
          {accolades(type, content)}

          {/*{header}*/}
          <div className="default-card-wrapper-content">
            <div className="card-info">
              {avatarAndTitle(type, content, logoBase64)}
              {showDescription && <>{descriptiveText(type, content)}</>}
              {details(type, content)}
              {separator()}
              {amenities(type, content)}
              {showBio && content.bio && profileBio(content.bio)}
              {showVendorProfile &&
                content.vendorProfile &&
                vendorProfile(content.vendorProfile)}
              {showSocialProfile &&
                content.socialProfile &&
                content.socialProfile.length > 0 && (
                  <SocialLinks
                    socialProfile={content.socialProfile}
                    condensed={false}
                  />
                )}
              {/*{pinned && pinnedIndicator}*/}
            </div>
            <div className="flex-grow" />
            {cta(type, content)}
          </div>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};
export default ContentCard;
